import { render, staticRenderFns } from "./PublishingTab.vue?vue&type=template&id=20240769&scoped=true"
import script from "./PublishingTab.vue?vue&type=script&lang=js"
export * from "./PublishingTab.vue?vue&type=script&lang=js"
import style0 from "./PublishingTab.vue?vue&type=style&index=0&id=20240769&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20240769",
  null
  
)

export default component.exports